import styled from '@emotion/styled';
import { theme } from '@kindur/components';
import React from 'react';
import Container from '../Common/Container';

export default (props: ColumnProps) => (
  <Container {...props}>
    <Content {...props}/>
  </Container>
);

/*
 *  STYLES
 */

const Content = styled('div')`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(3rem, 1fr));
  grid-gap: 1.5rem;

  ${theme.breakpoints.tabletDown} {
    grid-template-columns: 1fr;
  }
`;

export interface ColumnProps {
  backgroundColor?: string;
  children?: any;
  padding?: string;
}
